
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/investor-portfolio",
      function () {
        return require("private-next-pages/investor-portfolio.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/investor-portfolio"])
      });
    }
  